 <template>
 <div v-role="'adm'" class="mx-auto" style="max-width: 800px; height: 30px;margin:10px">
   <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
   <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
   <v-row justify="center">
     <v-dialog v-model="dialog2" persistent max-width="490">
              <v-card>
                <v-card-title class="headline">Desejas adicionar essa disciplina no certicado?</v-card-title>
                <v-card-text>Essa operação irá afectar a estrutura do certificado, desejas continuar com essa acção?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="dialog2=false">Não</v-btn>
                  <v-btn color="green darken-1" text @click="save_modelo_certificado()">Sim</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
           </v-row>
     <!-- =============================================================================== -->

            <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="490">
              <v-card>
                <v-card-title class="headline">Desejas continuar com essa operação?</v-card-title>
                <v-card-text>Essa operação irá afectar a estrutura do certificado, desejas continuar?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="dialog=false">Cancelar</v-btn>
                  <v-btn color="green darken-1" text @click="save()">Concordar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>

        <!-- =============================================== -->
        <!-- =============================================================================== -->

            <v-row justify="center">
            <v-dialog v-model="dialog4" persistent max-width="490">
              <v-card>
                <v-card-title class="headline">Essa disciplina já existe, clique no icon <v-icon>delete</v-icon> e de seguida pesquise pela disciplina para poder atribui-la a esse curso.</v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="dialog4=false; editedItem.disciplina=''">OK</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>

        <!-- =============================================== -->
   <v-spacer></v-spacer>
          <v-card >
            <v-alert :type="typemsg" v-if="alert">
              {{text}}
              </v-alert>
            <v-card-title>
              <span class="headline">Nova Disciplina </span>
              <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
<v-row>
    <v-col class="d-flex" cols="12" sm="10" md="10" ></v-col>
    <v-col class="d-flex" cols="12" sm="2" md="2">
      <v-btn  class="mx-2" fab dark color="primary" @click="reset()">
      <v-icon dark>refresh</v-icon>
          </v-btn>
      </v-col>
      </v-row>

            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form ref="form" v-model="formValid" lazy-validation >
                  <v-row>
                   <v-col class="d-flex" cols="12"  sm="6" >
                        <v-select
                          v-model="editedItem.curso"
                          return-object
                          :items="cursos"
                          item-value="idCurso"
                          item-text="descricao"
                          label="Cursos"
                          @change="initializeDisciplinas_curso()"
                          :rules="obrigqtorioRules"
                          dense
                          outlined
                        ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" v-if="isEditing">
                <v-text-field
                      v-model="editedItem.disciplina"
                      :rules="obrigqtorioRules"
                      label="Nome da Disciplina"
                      placeholder="Digite o nome da disciplina"
                      @change="verify_value_ON_Textfield()"
                      outlined
                  >
                  <template v-slot:append-outer>
                    <v-slide-x-reverse-transition  mode="out-in">
                      <v-icon
                      color="primary"
                      @click="set_editedItem_Disciplina()"
                      v-text="isEditing ? 'search' : 'add'"
                    ></v-icon>
                  </v-slide-x-reverse-transition>
                </template>
                </v-text-field>

                </v-col>

                  <v-col cols="12" sm="6" md="6" v-if="!isEditing">
                <v-autocomplete
                :disabled="!editedItem.curso"
                  v-model="editedItem.disciplina"
                  :rules="obrigqtorioRules"
                  :items="disciplinas"
                  :search-input.sync="search"
                  color="primary"
                  item-text="descricao"
                  item-value="iddisciplina"
                  label="Pesquise pela disciplina"
                  placeholder="Pesquise pela disciplina"
                  prepend-icon="mdi-database-search"
                  @change="initializeClasse()"
                  return-object>
                  <template v-slot:append-outer>
                    <v-slide-x-reverse-transition  mode="out-in">
                      <v-icon
                      color="primary"
                      @click="set_editedItem_Disciplina()"
                      v-text="isEditing ? 'add' : 'add'"
                    ></v-icon>
                  </v-slide-x-reverse-transition>
                </template>
                </v-autocomplete>
                </v-col>

                    <v-col class="d-flex" cols="12"  sm="6" >
                        <v-select
                          :items="bienais"
                          item-value="idbienal"
                          item-text="descricao"
                          label="Bienal"
                          :rules="obrigqtorioRules"
                          dense
                          outlined
                          v-model="editedItem.bienal"
                          @change="classesActivas()"
                          return-object
                        ></v-select>
                  </v-col>
                  <v-col class="d-flex" cols="12"  sm="6" >
                        <v-select
                          :items="componentes"
                          item-value="idcomponente"
                          item-text="descricao"
                          label="Componente"
                          :rules="obrigqtorioRules"
                          dense
                          outlined
                          v-model="editedItem.componente"
                          return-object
                        ></v-select>
                  </v-col>
                </v-row>
                </v-form>
              </v-container>
              <span style="color:red">*</span>
              Clique no ícone <v-icon color="green darken-3" size="25">save</v-icon> para cadastrar a disciplina da referida classe
            <v-alert :type="typemsg" v-if="alert">
              {{text}}
              </v-alert>
            </v-card-text>
             <v-data-table
    :headers="headers"
    :items="anoacademicos"
    :sort-desc="true"
    class="elevation-1"
   >
    <template v-slot:top>
      </template>
      <template v-slot:item.action="{ item }">
      <v-icon v-if="!item.status" color="green darken-3" size="25" :disabled=" !(formValid) || isLoading " @click="dialogOpen(item)">save</v-icon>
     </template>
    <template v-slot:no-data>
      no data
    </template>
  </v-data-table>
 </v-card></div>
</template>
<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    dialog4: false,
    existeModeloCertificado: true,
    curso: { descricao: '' },
    disciplinas_certificado: [ { descricao: '', controliddisciplina: 0, componente: 0 } ],
    item: null,
    anoacademico_chosen: null,
    dialog: false,
    cursoAlldisciplinas: [],
    isEditing: false,
    isLoading_: false,
    search: null,
    formValid: true,
    text: '',
    typemsg: 'error',
    isLoading: false,
    headers: [
      {
        text: 'Classe',
        align: 'left',
        sortable: false,
        value: 'descricao'
      },
      { text: 'Acção', value: 'action', sortable: false }
    ],
    allDisciplinas: [],
    anoacademicos: [],
    bienais: [{ idbienal: 1, descricao: 'Sim' }, { idbienal: 2, descricao: 'Não' }],
    componentes: [ { idcomponente: 1, descricao: 'Componente Sociocultural' }, { idcomponente: 2, descricao: 'Componente Cientifíca' }, { idcomponente: 3, descricao: 'Componente Técnica, Tecnológica e Prática' } ],
    cursos: [],
    obrigqtorioRules: [ value => !!value || 'campo obrigatório.' ],
    disciplinas: [],
    quant_insert: 1,
    alert: false,
    formValid2: false,
    dialog2: false,
    anolectivo: { idAnoLectivo: ls.get('idanolectivo'), novadescricao: ls.get('novadescricao') },
    editedIndex: -1,
    editedItem: {
      disciplina: null,
      iddisciplina: 0,
      curso: 0,
      anoacademico: 0,
      bienal: 0,
      componente: 0,
      controliddisciplina: 0,
      autor: ls.get('nomeUsuario')
    },
    defaultItem: {
      disciplina: null,
      iddisciplina: 0,
      curso: 0,
      descricao: '',
      anoacademico: 0,
      bienal: 0,
      componente: 0,
      controliddisciplina: 0,
      autor: ls.get('nomeUsuario')
    }
  }),

  computed: {

  },

  watch: {
    search (val) {
      // Items have already been loaded
      if (val.length > 0) {
      // Items have already been requested
        if (!this.disciplinas.filter(t => (t.descricao.toUpperCase()).includes(val.toUpperCase())).length) {
          this.disciplinas = []
        }
        return this.initializeDisciplinas(val)
      }
    }

  },

  created () {
    this.initialize_curso()
    this.initializeClasse()
    this.initializeDisciplinas()
  },

  methods: {
    set_editedItem_Disciplina () {
      this.editedItem.disciplina = ''
      this.isEditing = !this.isEditing
      if (this.isEditing) {
        this.initializeAllDisciplinas()
      }
      this.initializeClasse()
    },
    set_disciplinaSelectedOnAutocomplete_editedItem_disciplina () {
      /** Filtra as disciplinas com o mesmo curso e  controliddisciplina */
      let arrayDisciplina_curso = (this.cursoAlldisciplinas.filter(d => (d.idCurso === this.editedItem.disciplina.idCurso && (d.descricao.toLowerCase()) === (this.editedItem.disciplina.descricao.toLowerCase()))))
     this.isLoading_ = true
      if (this.editedItem.disciplina.descricao && this.cursoAlldisciplinas.length) {
        arrayDisciplina_curso.forEach(element => {
          for (let index = 0; index < this.anoacademicos.length; index++) {
            if (element.anoacademico === this.anoacademicos[index].idAno_Academico) {
              this.editedItem.bienal = { idbienal: (element.bienal === 0 ? 2 : 1), descricao: (element.bienal === 0 ? 'Não' : 'Sim') }
              this.editedItem.componente = { idcomponente: (element.componente), descricao: (element.componente === 1 ? 'Componente Sociocultural' : (element.componente === 2 ? 'Componente Cientifíca' : (element.componente === 3 ? 'Componente Técnica, Tecnológica e Prática' : ''))) }
              this.quant_insert++
              this.anoacademicos[index].status = true
              index = this.anoacademicos.length
            }
          }
        })
      }
    },
    async initialize_curso () {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
    async initializeClasse () {
      try {
        this.isLoading = true
        this.isLoading_ = true
        this.anoacademicos = await axios
          .get('/anoacademicoAll')
          .then(res => res.data)
        this.isLoading = false
        this.set_disciplinaSelectedOnAutocomplete_editedItem_disciplina()
      } catch (error) {
        this.isLoading = false
      }
    },
    dialogOpen (item) {
      if (this.$refs.form.validate()) {
        this.anoacademico_chosen = item
        this.dialog = true
      }
    },

    async save () {
      this.dialog = false
      let index_ = this.anoacademicos.indexOf(this.anoacademico_chosen)
      if (this.$refs.form.validate()) {
        this.alert = false
        this.curso = this.editedItem.curso
        let params = {
          iddisciplina: this.editedItem.iddisciplina,
          disciplina: (this.editedItem.disciplina.descricao ? this.editedItem.disciplina.descricao : this.editedItem.disciplina),
          bienal: (this.editedItem.bienal.idbienal === 2 ? 0 : this.quant_insert),
          componente: this.editedItem.componente.idcomponente,
          curso: this.editedItem.curso.idCurso,
          anoacademico: this.anoacademico_chosen.idAno_Academico,
          controliddisciplina: (this.editedItem.disciplina.controliddisciplina ? this.editedItem.disciplina.controliddisciplina : this.editedItem.controliddisciplina),
          autor: ls.get('nomeUsuario')
        }
        try {
          this.isLoading = true
          let msg = await axios
            .post('/disciplinaInsertOrUpdate', params)
            .then(res => res.data)
          if (msg[0].length) {
            // Se a Bienal for Anual armazena a quantidade de inserts feitos
            if (this.editedItem.bienal.idbienal !== 2) {
              /** Pegando o  controliddisciplina inserido */
              this.editedItem.controliddisciplina = (msg[0])[0].controliddisciplina
              params.controliddisciplina = (msg[0])[0].controliddisciplina
              this.quant_insert++
              this.classeDesactivar_Activar(index_)
            } else
            if (this.editedItem.bienal.idbienal === 2) this.disciplina_In_ModeloCertificado(params)
            /** Configurando o Alert */
            this.typemsg = 'success'
            this.alert = true
            this.text = 'Disciplina salva com Sucesso!'
            this.initializeAllDisciplinas()
            /** Verificar se já existe essa disciplina no certificado */
            this.disciplina_In_ModeloCertificado(params)
          }
          this.isLoading = false
          this.dialog = false
          setTimeout(() => {
            this.alert = false
            this.reset()
          }, 1000)
        } catch (error) {
          this.dialog = false
          this.isLoading = false
          this.alert = false
          this.text = error.message
          this.typemsg = 'error'
        }
      }
    },
    /** Verificar se já existe essa disciplina no certificado */
    async disciplina_In_ModeloCertificado (params) {
      try {
        let msg = await axios
          .post('/disciplinaIn_ModeloCertificado', { idCurso: params.curso, controliddisciplina: params.controliddisciplina, idAnoLectivo: this.anolectivo.idAnoLectivo })
          .then(res => res.data)
        if (msg.length === 0) {
          this.load_modelo_certificado(params)
        } else {
          this.reset()
        }
      } catch (error) {

      }
    },
    classeDesactivar_Activar (index_) {
      this.anoacademicos[(this.anoacademicos.length) - 1].status = false
      for (let i = 0; i <= index_; i++) {
        this.anoacademicos[i].status = true
      }
    },
    classesActivas () {
      if (this.editedItem.bienal.idbienal === 1) {
        this.anoacademicos[(this.anoacademicos.length) - 1].status = true
      } else {
        if (this.editedItem.bienal.idbienal === 2) {
          this.anoacademicos[(this.anoacademicos.length) - 1].status = false
        }
      }
    },
    async initializeDisciplinas (searchDB) {
      this.isLoading_ = true
      if (!this.disciplinas.length) {
        try {
          this.disciplinas = await axios
            .post('/disciplinaFindDescricao', { search: searchDB })
            .then(res => res.data)
          this.isLoading_ = false
        } catch (error) {
          this.isLoading_ = false
          this.$store.dispatch('textMessage', {
            msg: error,
            classMessage: 'msgError',
            timeout: 3000
          })
        }
      }
    },
    async initializeDisciplinas_curso () {
      try {
        this.cursoAlldisciplinas = await axios
          .post('/disciplina_curso', this.editedItem.curso)
          .then(res => res.data)
      } catch (error) {
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    validate () {
      this.$refs.form.validate()
    },
    reset () {
      this.$refs.form.reset()
      this.initializeClasse()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    async save_modelo_certificado () {
      try {
        this.overlay = true
        let msg2 = await axios
          .post('/modelodisciplinaInsert', { dados: this.disciplinas_certificado, curso: this.curso, anolectivo: this.anolectivo, status_: true, autor_: ls.get('nomeUsuario') })
          .then(res => res.data)
        if (msg2.affectedRows > 0) {
          this.typemsg = 'success'
          this.alert = true
          this.text = 'Operação feita com Sucesso!'
          this.reset()
          this.dialog2 = false
          setTimeout(() => {
            this.alert = false
          }, 2000)
        }
        this.overlay = false
      } catch (error) {
        this.overlay = false
        this.dialog2 = false
        this.alert = true
        this.colorAlert = 'error'
        this.msgAlert = error
        setTimeout(() => {
          this.alert = false
        }, 2000)
      }
    },
    async load_modelo_certificado (params) {
      try {
        let msg = await axios
          .post('/load_modelo', { idCurso: params.curso, idAnoLectivo: this.anolectivo.idAnoLectivo })
          .then(res => res.data)
        if (msg.length > 0) {
          this.dialog2 = true
          this.disciplinas_certificado = [ { descricao: params.disciplina, controliddisciplina: params.controliddisciplina, componente: params.componente } ]
        }
      } catch (error) {
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async initializeAllDisciplinas () {
      this.isLoading_ = false
      try {
        this.allDisciplinas = await axios
          .get('/allDisciplina')
          .then(res => res.data)
        this.isLoading_ = true
      } catch (error) {
        this.isLoading_ = true
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    verify_value_ON_Textfield () {
      if (!this.allDisciplinas.filter(t => (t.descricao.toUpperCase()) === (this.editedItem.disciplina.toUpperCase())).length) {
        this.dialog4 = false
      } else {
        this.dialog4 = true
      }
    }
  }
}
</script>
